module.exports = __webpack_public_path__ + "images/a2a35d3ba790c717f6506e9defec82c5.png";